import { render, staticRenderFns } from "./BigContent.vue?vue&type=template&id=64427284&"
import script from "./BigContent.vue?vue&type=script&lang=js&"
export * from "./BigContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports